import { render, staticRenderFns } from "./Scars.vue?vue&type=template&id=9e24f356&scoped=true&"
import script from "./Scars.vue?vue&type=script&lang=js&"
export * from "./Scars.vue?vue&type=script&lang=js&"
import style0 from "./Scars.vue?vue&type=style&index=0&id=9e24f356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e24f356",
  null
  
)

export default component.exports